const siteLanguageList = [
  {
    code: 'en',
    name: 'English',
    released: true,
  },
  {
    code: 'ar',
    name: 'العربية',
    released: true,
  },
  {
    code: 'ca',
    name: 'Català',
    released: false,
  },
  {
    code: 'es-419',
    name: 'Español (Latinoamérica)',
    released: true,
  },
  {
    code: 'fa-ir',
    name: 'فارسی',
    released: true,
  },
  {
    code: 'fr',
    name: 'Français',
    released: true,
  },
  {
    code: 'he',
    name: 'עברית',
    released: false,
  },
  {
    code: 'id',
    name: 'Bahasa Indonesia',
    released: false,
  },
  {
    code: 'ko-kr',
    name: '한국어 (대한민국)',
    released: false,
  },
  {
    code: 'pl',
    name: 'Polski',
    released: false,
  },
  {
    code: 'pt-br',
    name: 'Português (Brasil)',
    released: false,
  },
  {
    code: 'ru',
    name: 'Русский',
    released: false,
  },
  {
    code: 'th',
    name: 'ไทย',
    released: false,
  },
  {
    code: 'uk',
    name: 'Українська',
    released: false,
  },
  {
    code: 'zh-cn',
    name: '中文 (简体)',
    released: true,
  },
  {
    code: 'pt-pt',
    name: 'Português',
    released: true,
  },
  {
    code: 'it-it',
    name: 'Italian',
    released: true,
  },
  {
    code: 'de-de',
    name: 'German',
    released: true,
  },
  {
    code: 'hi',
    name: 'Hindi',
    released: true,
  },
  {
    code: 'fr-ca',
    name: 'French (CA)',
    released: true,
  },
  {
    code: 'te',
    name: 'తెలుగు',
    released: true,
  },
  {
    code: 'da',
    name: 'dansk',
    released: true,
  },
  {
    code: 'el',
    name: 'Ελληνικά',
    released: true,
  },
  {
    code: 'es-es',
    name: 'Español (España)',
    released: true,
  },
  {
    code: 'sw',
    name: 'Kiswahili',
    released: true,
  },
  {
    code: 'tr-tr',
    name: 'Türkçe (Türkiye)',
    released: true,
  },
];

export default siteLanguageList;
